import { GroundHazardDocument } from '../GroundHazard/queryBuilder';
import { create } from '../replication-v2/FamilyMember/create';
import { FamilyMember } from '../replication-v2/FamilyMember/FamilyMember';
import { ConfigBuilder, doNotAutoSync, pull, push, replicate } from '../replication-v2/replicate';
import { RxdbCollectionNameV2 } from '../replication-v2/RxdbCollectionNameV2';
import {
  GroundHazardAttachmentDocument,
  groundHazardAttachmentPushQueryBuilder,
  groundHazardAttachmentsPullQueryBuilder,
} from './queryBuilder';

export function groundHazardAttachmentsFamilyMember(
  configBuilder: ConfigBuilder,
  groundHazards: FamilyMember<GroundHazardDocument>,
): FamilyMember<GroundHazardAttachmentDocument> {
  const syncConfig = configBuilder<GroundHazardAttachmentDocument>(
    RxdbCollectionNameV2.GROUND_HAZARDS_ATTACHMENTS,
  );
  doNotAutoSync(syncConfig);

  pull(syncConfig, groundHazardAttachmentsPullQueryBuilder);
  push(syncConfig, groundHazardAttachmentPushQueryBuilder);

  const replicationState = replicate(syncConfig);
  return create(RxdbCollectionNameV2.GROUND_HAZARDS_ATTACHMENTS, replicationState, [groundHazards]);
}
